import React from 'react';
import { Col } from '@thd-olt-component-react/core-ui';
import { string, bool } from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { useParams, useLocation } from '@thd-olt-component-react/router';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';

export const StoreFinderBreadcrumbs = ({
  includeDirectory, pageName
}) => {
  const {
    storeNumber, storeZip, state, name, city
  } = useParams();
  const path = useLocation();
  const breadcrumb = [
    {
      label: 'Home',
      url: '/'
    },
    {
      label: 'Store Finder',
      url: '/l/'
    },
    {
      label: 'Store Directory',
      url: '/l/storeDirectory'
    },
  ];
  if (includeDirectory) {
    breadcrumb.push({
      label: `${state}`,
      url: `/l/${state}`
    }, {
      label: `${name}`,
      url: `/l/${name}/${state}/${city}/${storeZip}/${storeNumber}`
    })
  }
  if (pageName) {
    breadcrumb.push({
      label: `${pageName}`,
      url: `${path.pathname}`
    })
  }
  return (
    <Col fallback={12}>
      <Breadcrumbs
        staticCrumbs={breadcrumb}
      />
    </Col>
  );
};

StoreFinderBreadcrumbs.displayName = 'StoreFinderBreadcrumbs';
StoreFinderBreadcrumbs.propTypes = {
  includeDirectory: bool,
  pageName: string,
}
StoreFinderBreadcrumbs.defaultProps = {
  includeDirectory: false,
  pageName: '',
}

StoreFinderBreadcrumbs.dataModel = extend({},
  Breadcrumbs
);
